import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { getJwt, postJwt } from '../../helpers/clearnet_api_helper';
import CSDateInput from '../../components/Common/CSDateInput';
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
//import { MsgType, showOkModal, showYesNoModal } from '../../components/Common/ModalManager';
//import Autocomplete from 'react-autocomplete';
//import * as signalR from "@microsoft/signalr";
import { Link } from "react-router-dom";
//import { getTodayDDMMYYYY } from '../../helpers/clearnet_utils';
import { getUserInfo, userStatus } from './CSHHelper';
import { useCSHMessage } from "./useCSHMessage";
import "../../assets/clearstone/styles.css";
import "../../assets/clearstone/checkbox-bold.css";
import '../../assets/clearstone/cs-flexheaderbar.css';





//const API_URL = User.env.REACT_APP_API_URL;




const User = () => {

    let { id } = useParams(); // get id User param
    const location = useLocation(); // <- added
    //const [User, setUser] = useState();
    const [roles, setRoles] = useState([{ value: '', text: '--Please select a role--' }]);
    // Fetch roles list
    useEffect(() => {
        getJwt(`api/ClearStoneHub/Roles/roleslist`).then(response => {
            setRoles([
                { value: '', text: '--Please select a role--' },
                ...response.map(r => ({
                    value: String(r.value).toLowerCase(),
                    text: r.text
                }))
            ]);
        });
    }, []);
    const [originalUser, setOriginalUser] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    // determine if we're in Info (read-only) view and get query id if present
    const searchParams = new URLSearchParams(location.search);
    const queryId = searchParams.get('id');

    // const isPathIdNumeric = typeof id !== 'undefined' && /^[0-9]+$/.test(String(id));
    // id = isPathIdNumeric ? String(id) : (queryId || "0");
    const isPathIdGuid = typeof id !== 'undefined' && /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(String(id));
    id = isPathIdGuid ? String(id) : (queryId || null);


    const isReadOnly = location.pathname.toLowerCase().includes('/info') && !!queryId;

    const { userEmail, userRole } = getUserInfo();

    const [showMessage, message] = useCSHMessage();

    const { register, handleSubmit, formState: { errors, isDirty }, reset } = useForm({

        defaultValues: {

            firstName: "",
            lastName: "",
            email: "",
            roleId: "", // default to empty, force user to select
            status: "", // default to empty, force user to select
        }
    });

    // console.log(
    //     "User:",
    //     JSON.stringify(User, null, 2)
    // );


    // useEffect(() => {
    //     if (User) {
    //         JSON.stringify(User, null, 2);
    //     }
    // }, [User]);

    useEffect(() => {

        setIsLoading(true);

        // Fetch initial data here 
        try {

            if (id) {
                fetchUser();
            }
            else {
                fetchDefaultUser();
            }

        }
        finally {
            setIsLoading(false);
        }
    }, [id]);



    const fetchDefaultUser = async () => {
        try {
            const response = await getJwt('api/clearstonehub/users/default');
            reset(response); // set default values for the RHF form
            //setUser({ ...response, roleId: response.roleId ? String(response.roleId) : '' });
            setOriginalUser({ ...response, roleId: response.roleId ? String(response.roleId) : '' });
        } catch (error) {
            //console.error('Error fetching default User:', error);
            //setUser(null); // or fallback to a hardcoded default
            await showMessage({ message: "" + (error?.message || 'Unknown error'), messageType: "danger" });
        }
    };


    const fetchUser = async () => {
        try {
            const response = await getJwt(`api/clearstonehub/users/${id}`); // pass id as User param
            reset(response); // set default values for the RHF form
            //setUser({ ...response, roleId: response.roleId ? String(response.roleId) : '' });
            setOriginalUser({ ...response, roleId: response.roleId ? String(response.roleId) : '' });
        } catch (error) {
            //console.error('Error fetching data:', error);
            await showMessage({ message: "" + (error?.message || 'Unknown error'), messageType: "danger" });
        }
    };

    // const fetchInstanceOptions = async () => {
    //     try {
    //         const response = await getJwt('api/Lookups/instances');
    //         setInstanceOptions(response || []);
    //     } catch (error) {
    //         console.error('Error fetching instance options:', error);
    //         setInstanceOptions([]);
    //     }
    // };


    // const handleChange = (e) => {
    //     if (isReadOnly) return; // prevent edits in read-only mode
    //     //console.log("handleChange fired", e.target.name, e.target.type, e.target.checked, e.target.value);
    //     const { name, value, type, checked } = e.target;
    //     setUser((prev) => ({
    //         ...prev,
    //         [name]: type === "checkbox" ? checked : value,
    //     }));
    // };

    // workaround for checkboxes click event since onChange doesn't always trigger properly for checkboxes
    // const handleCheckbox = (e) => {
    //     if (isReadOnly) return;
    //     const { name } = e.target;
    //     setUser(prev => ({
    //         ...prev,
    //         [name]: !prev[name]
    //     }));
    // };


    const handleCancel = () => {

        // In read-only mode or new User, just navigate back
        if (isReadOnly || !id) {
            navigate(-1);
        } else {
            // Compare if data has changed
            if (!isDirty) {
                //if (JSON.stringify(originalUser) === JSON.stringify(User)) {
                navigate(-1);
            } else {
                // Data has changed, clear changes
                //setUser(originalUser); // Revert to original data
                reset(originalUser); // reset form to original data                
            }
        }
    };

    // const handleSave = async () => {
    //     if (isReadOnly) return;
    //     try {
    //         let response;
    //         //const payload = cleanUserForApi(User);
    //         const payload = {
    //             user: User,         // property name should match backend: "user"
    //             adminEmail: userEmail // property name should match backend: "adminEmail"
    //         };
    //         if (!id) {
    //             response = await postJwt('api/clearstonehub/users', payload, { method: "POST" });
    //         } else {
    //             response = await postJwt(`api/clearstonehub/users/${id}`, payload, { method: "PUT" });
    //         }


    //         // After saving, navigate to the new User or update originalUser
    //         if (!id) {
    //             navigate(`/ClearStoneHub/Users/${response?.id}`);
    //         } else {
    //             setOriginalUser(User);
    //         }
    //     } catch (error) {
    //         await showMessage({ message: "" + (error?.message || 'Unknown error'), messageType: "danger" });
    //     }
    // };

    const onSubmit = async (data) => {
        if (isReadOnly) return;
        try {
            let response;
            const payload = {
                user: data,
                adminEmail: userEmail
            };
            if (!id) {
                response = await postJwt('api/clearstonehub/users', payload, { method: "POST" });
            } else {
                response = await postJwt(`api/clearstonehub/users/${id}`, payload, { method: "PUT" });
            }

            await showMessage({ message: "Saved successfully.", messageType: "success" });

            if (!id) {
                navigate(`/ClearStoneHub/Users/${response?.id}`, { replace: true });
            } else {
                reset(response); // update form with any changes returned from API (e.g. updated timestamps)
                setOriginalUser(response);
            }
        } catch (error) {
            await showMessage({ message: "" + (error?.message || 'Unknown error'), messageType: "danger" });
        }
    };

    // const cleanUserForApi = (User) => ({
    //     Id: User.id || 0,
    //     Name: User.name || "",
    //     Path: User.path || "",
    //     Active: !!User.active,
    //     IsArchive: !!User.isArchive,
    //     // not used in edit form but required by API        
    //     Files: Array.isArray(User.files) ? User.files : [],
    //     Monitors: Array.isArray(User.monitors) ? User.monitors : [],
    //     FileUsers: Array.isArray(User.fileUsers) ? User.fileUsers : [],
    // });



    // Reset form when User changes
    // useEffect(() => {
    //     if (User) reset(User);
    // }, [User, reset]);

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title='ClearStoneHub User'
                    items={[
                        { label: <>ClearStoneHub</>, link: "/ClearStoneHub" },
                        { label: <>Users</>, link: "/ClearStoneHub/Users" },
                        { label: <> User</> }
                    ]}
                />


                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit(onSubmit)}>

                            {/* <h3 className="card-title" style={{ marginBottom: 24 }} >
                                 User
                            </h3> */}

                            {/* keep the existing content inside the card body so layout matches Formats */}
                            {originalUser && (
                                <>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="panel panel-default">

                                                {/* Details Section */}
                                                <div
                                                    className="flex-header-bar"
                                                >
                                                    <h3 className="card-title">Details</h3>
                                                </div>

                                                <div className="panel-body">

                                                    <div className="form-group" style={{ marginBottom: "1.5rem" }}>
                                                        <label style={{ fontWeight: "bold" }}>
                                                            Email<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            readOnly={isReadOnly}
                                                            style={{ width: "100%", marginBottom: 0 }}
                                                            {...register("email", {
                                                                required: "Email is required",
                                                                pattern: {
                                                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                                    message: "Please enter a valid email address"
                                                                }
                                                            })}
                                                        />
                                                        {errors.email && (
                                                            <span className="text-danger" style={{ display: "block", marginTop: 4 }}>
                                                                {errors.email.message}
                                                            </span>
                                                        )}
                                                    </div>


                                                    <div className="form-group" style={{ marginBottom: "1.5rem" }}>
                                                        <label style={{ fontWeight: "bold" }}>
                                                            Name<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            readOnly={isReadOnly}
                                                            style={{ width: "100%", marginBottom: 0 }}
                                                            {...register("firstName", { required: "First name is required" })}
                                                        />
                                                        {errors.firstName && (
                                                            <span className="text-danger" style={{ display: "block", marginTop: 4 }}>
                                                                {errors.firstName.message}
                                                            </span>
                                                        )}
                                                    </div>


                                                    <div className="form-group" style={{ marginBottom: "1.5rem" }}>
                                                        <label style={{ fontWeight: "bold" }}>
                                                            Last Name<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            readOnly={isReadOnly}
                                                            style={{ width: "100%", marginBottom: 0 }}
                                                            {...register("lastName", { required: "Last name is required" })}
                                                        />
                                                        {errors.lastName && (
                                                            <span className="text-danger" style={{ display: "block", marginTop: 4 }}>
                                                                {errors.lastName.message}
                                                            </span>
                                                        )}
                                                    </div>


                                                    <div className="form-group" style={{ marginBottom: "1.5rem" }}>
                                                        <label style={{ fontWeight: "bold" }}>
                                                            Role<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <select
                                                            className="form-control"
                                                            disabled={isReadOnly}
                                                            style={{
                                                                width: "100%",
                                                                marginBottom: 0,
                                                                appearance: "auto", // This tells the browser to use the native arrow
                                                                WebkitAppearance: "auto",
                                                                MozAppearance: "auto"
                                                            }}
                                                            {...register("roleId", {
                                                                required: "Role is required."
                                                            })}
                                                        >
                                                            {roles.map(role => (
                                                                <option key={role.value || role.text} value={role.value}>
                                                                    {role.text}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.roleId && (
                                                            <span className="text-danger" style={{ display: "block", marginTop: 4 }}>
                                                                {errors.roleId.message}
                                                            </span>
                                                        )}
                                                    </div>


                                                    <div className="form-group" style={{ marginBottom: "1.5rem" }}>
                                                        <label style={{ fontWeight: "bold" }}>
                                                            Status<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <select
                                                            className="form-control"
                                                            disabled={isReadOnly}
                                                            style={{
                                                                width: "100%",
                                                                marginBottom: 0,
                                                                appearance: "auto", // This tells the browser to use the native arrow
                                                                WebkitAppearance: "auto",
                                                                MozAppearance: "auto"
                                                            }}
                                                            {...register("status", { required: "Status is required." })}
                                                        >
                                                            {Object.entries(userStatus).map(([value, text]) => (
                                                                <option key={value} value={value}>
                                                                    {text}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.status && (
                                                            <span className="text-danger" style={{ display: "block", marginTop: 4 }}>
                                                                {errors.status.message}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <div className="row ls_divider last">
                                                        <div className="form-group">
                                                            <label className="col-md-2 control-label" />
                                                            <div className="col-md-10 ls-group-input">
                                                                {!isReadOnly && (
                                                                    <button type="submit" className="btn-primary btn">Save</button>
                                                                )}&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-default"
                                                                    onClick={() => handleCancel()}
                                                                    style={{
                                                                        border: '1px solid #ced4da',
                                                                        borderRadius: '4px'
                                                                    }}
                                                                >
                                                                    {isReadOnly ? "Back" : "Cancel"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>






                                </>
                            )}


                            {/* Loader */}
                            <div>
                                {isLoading && <div style={{ textAlign: 'center', marginTop: '20px' }}>Loading...</div>}
                                {!isLoading && !originalUser && <div style={{ textAlign: 'center', marginTop: '20px' }}>No results available</div>}
                                {/* Intersection Observer- when the div becomes visible (isIntersecting) the fetchUser function is triggered */}
                                {/* <div ref={observerRef} style={{ height: '1px' }}></div> */}
                            </div>

                            {message}

                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default User;